import type { Policy } from '../../../../shared/model-typings';
import { queryClient, useMutation } from '../../../ReactQuery';
import { remove } from '../../../redux/api';
import type { PolicyId } from '../../../types';

const removePolicyRules = (policyId: PolicyId, ruleIds: number[]) => {
  return remove<{ ruleIds: number[] }, Policy>(`/api/policies/${policyId}/rules`, {
    body: { ruleIds },
    json: true,
  });
};

/**
 * hook for deleting multiple policy rules
 */
export default function useDeletePolicyRules() {
  return useMutation({
    mutationFn: (params: { policyId: PolicyId; ruleIds: number[] }) =>
      removePolicyRules(params.policyId, params.ruleIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['policy'] });
    },
  });
}
